import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ServiceIntro from '../../components/ServiceIntro/ServiceIntro';
import ProductList from '../../components/ProductList/ProductList';
import productsData from '../../data/products.json';

const customsContent = {
  title: "房产市场洞察与投资分析系统",
  subtitle: "专业的房产数据分析服务",
  description: {
    mainText: "房产市场洞察与投资分析系统专注于为房地产投资领域提供全方位的数据分析与智能决策支持，致力于解决房地产市场信息不透明、数据孤立、投资决策依据不足等核心问题。通过精准的数据采集、专业的市场趋势预测和多维度的风险评估，我们帮助地产投资者、基金管理公司和城市经济研究机构实现精准投资和高效决策。",
    systemTitle: "核心价值与亮点：",
    systems: [
      "精准市场动态监测与预测：实时跟踪房地产市场动态，确保用户决策基于最新、最准确的数据支持。",
      "多维度数据整合与分析：聚合多源异构数据，提供多维度的深度数据分析，帮助用户快速识别高潜力投资机会。",
      "智能决策与风险评估：通过内置先进风险评估模型与模拟工具，助力用户制定优化的投资决策组合。"
    ],
    conclusion: {
      title: "系统优势与应用场景：",
      content: [
        "我们的系统广泛适用于地产投资机构、房产基金公司、房地产评估企业及跨境置业投资者，涵盖多种业务需求与应用场景，帮助用户更科学、更高效地洞察市场趋势，降低投资风险，实现资产增值。我们的专业数据分析团队，凭借丰富的行业经验与强大的技术实力，持续为您提供最具竞争力的房地产数据分析和投资策略建议。选择我们的房产市场洞察与投资分析系统，助力您在房地产投资领域抢占先机，稳定实现长期投资回报。"
      ]
    }
  },
  image: "/images/solutions/house.png"
};

const customsProducts = {
  title: "我们的产品",
  subtitle: "房产数据分析解决方案",
  products: productsData.realEstateProducts
};

const Customs = () => {
  return (
    <div className="customs-page flex flex-col min-h-screen">
      <Navbar />
      <ServiceIntro {...customsContent} />
      <ProductList {...customsProducts} />
      <div className='mt-auto'  style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Customs; 